import * as React from 'react';
import { cva, type VariantProps } from 'class-variance-authority';
import { cn } from './utils';

const buttonVariants = cva(
  'inline-flex items-center justify-center rounded-md text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none ring-offset-background',
  {
    variants: {
      variant: {
        success: 'bg-green-600 text-white hover:bg-green-700',
        outline: 'border border-green-600 text-green-600 hover:bg-green-50',
        ghost: 'hover:bg-green-50 text-green-700',
        danger: 'bg-red-600 text-white hover:bg-red-700',
        secondary: 'bg-gray-500 text-white hover:bg-gray-600',
        warning: 'bg-yellow-500 text-white hover:bg-yellow-600',
        info: 'bg-sky-500 text-white hover:bg-sky-600',
      },
      size: {
        default: 'h-10 px-4 py-2',
        sm: 'h-9 px-3',
        lg: 'h-11 px-8',
      },
    },
    defaultVariants: {
      variant: 'success',
      size: 'default',
    },
  }
);

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {}

function Button({ className, variant, size, ...props }: ButtonProps) {
  return <button className={cn(buttonVariants({ variant, size, className }))} {...props} />;
}

export { Button, buttonVariants };
